"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areKpiAlertFiltersSameAsDashboard = exports.isKpiAlertDateFilterSameAsDashboard = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var last_1 = tslib_1.__importDefault(require("lodash/last"));
var sortBy_1 = tslib_1.__importDefault(require("lodash/sortBy"));
function isKpiAlertDateFilterSameAsDashboard(alert, appliedFilters) {
    var _a, _b, _c;
    var alertDateFilter = (_a = alert === null || alert === void 0 ? void 0 : alert.filterContext) === null || _a === void 0 ? void 0 : _a.filters.find(sdk_model_1.isDashboardDateFilter);
    var appliedDateFilter = last_1.default(appliedFilters.filter(sdk_model_1.isDateFilter));
    if (!alertDateFilter) {
        return !appliedDateFilter || sdk_model_1.isAllTimeDateFilter(appliedDateFilter);
    }
    if (!appliedDateFilter || sdk_model_1.isAllTimeDateFilter(appliedDateFilter)) {
        return false;
    }
    if (sdk_model_1.isRelativeDateFilter(appliedDateFilter)) {
        var _d = sdk_model_1.relativeDateFilterValues(appliedDateFilter), from = _d.from, granularity = _d.granularity, to = _d.to;
        var sameType = alertDateFilter.dateFilter.type === "relative";
        var sameFrom = ((_b = alertDateFilter.dateFilter.from) === null || _b === void 0 ? void 0 : _b.toString()) === from.toString();
        var sameTo = ((_c = alertDateFilter.dateFilter.to) === null || _c === void 0 ? void 0 : _c.toString()) === to.toString();
        var sameGranularity = alertDateFilter.dateFilter.granularity === granularity;
        return [sameType, sameFrom, sameTo, sameGranularity].every(Boolean);
    }
    else {
        var _e = sdk_model_1.absoluteDateFilterValues(appliedDateFilter), from = _e.from, to = _e.to;
        var sameType = alertDateFilter.dateFilter.type === "absolute";
        var sameFrom = alertDateFilter.dateFilter.from === from;
        var sameTo = alertDateFilter.dateFilter.to === to;
        return [sameType, sameFrom, sameTo].every(Boolean);
    }
}
exports.isKpiAlertDateFilterSameAsDashboard = isKpiAlertDateFilterSameAsDashboard;
function areKpiAlertAttributeFiltersSameAsDashboard(alert, appliedFilters) {
    var _a, _b;
    var alertAttributeFilters = (_b = (_a = alert.filterContext) === null || _a === void 0 ? void 0 : _a.filters.filter(sdk_model_1.isDashboardAttributeFilter)) !== null && _b !== void 0 ? _b : [];
    var appliedAttributeFilters = appliedFilters.filter(sdk_model_1.isAttributeFilter);
    // empty filter is modelled as negative filter with no elements
    var alertAttributeFiltersWithoutEmpty = alertAttributeFilters.filter(function (filter) {
        return !(filter.attributeFilter.negativeSelection &&
            sdk_model_1.attributeElementsIsEmpty(filter.attributeFilter.attributeElements));
    });
    var appliedAttributeFiltersWithoutEmpty = appliedAttributeFilters.filter(function (filter) { return !(sdk_model_1.isNegativeAttributeFilter(filter) && sdk_model_1.filterIsEmpty(filter)); });
    // the filters are considered the same if the count of non-empty filters is matching
    // and every filter in alert has an equivalent in the applied filters
    return (appliedAttributeFiltersWithoutEmpty.length === alertAttributeFiltersWithoutEmpty.length &&
        appliedAttributeFiltersWithoutEmpty.every(function (filter) {
            var displayForm = sdk_model_1.filterObjRef(filter);
            var found = alertAttributeFiltersWithoutEmpty.find(function (alertFilter) {
                return sdk_model_1.areObjRefsEqual(alertFilter.attributeFilter.displayForm, displayForm);
            });
            if (!found) {
                return false;
            }
            var negativeSelectionSame = found.attributeFilter.negativeSelection === sdk_model_1.isNegativeAttributeFilter(filter);
            var filterElements = sdk_model_1.filterAttributeElements(filter);
            var elementsSame = sdk_model_1.isAttributeElementsByRef(filterElements) && // TODO what about filters by value?
                sdk_model_1.isAttributeElementsByRef(found.attributeFilter.attributeElements) && // TODO what about filters by value?
                isEqual_1.default(sortBy_1.default(found.attributeFilter.attributeElements.uris), sortBy_1.default(filterElements.uris));
            return negativeSelectionSame && elementsSame;
        }));
}
function areKpiAlertFiltersSameAsDashboard(alert, appliedFilters) {
    return (!!alert &&
        isKpiAlertDateFilterSameAsDashboard(alert, appliedFilters) &&
        areKpiAlertAttributeFiltersSameAsDashboard(alert, appliedFilters));
}
exports.areKpiAlertFiltersSameAsDashboard = areKpiAlertFiltersSameAsDashboard;
//# sourceMappingURL=filterUtils.js.map